<template>
    <div ref="distributionMapElement" class="mapview"></div>
</template>

<script>

    export default {
        props: {
            chartName: {
                type: String,
                required: true
            }
        },
        mounted() {
            this.getMap();
        },
        data: () => ({
            map: null
        }),
        beforeDestroy: function () {
            if(this.map)
                this.map.dispose();
        },
        methods: {
            getMap (){
                this.$store.dispatch("getDataViewChart", {
                    name: this.chartName,
                    filters: null
                }).then((data) => {
                    this.getDistributionMap(data)
                });
            },
            getDistributionMap (data) {
                let mapCenter = [0, 0];
                let pins = [];

                data.series[0].data.forEach((route) => {
                    // Center for last main depot
                    mapCenter = [route.location.lon, route.location.lat];

                    let mainDepot = new atlas.data.Feature(new atlas.data.Point([route.location.lon, route.location.lat]), {
                        title: route.locationName,
                        isDepot: true
                    });

                    pins.push(mainDepot);
                    this.getDistributionMapPins(route, pins);
                });

                this.map = new atlas.Map(this.$refs.distributionMapElement, {
                    center: mapCenter,
                    zoom: 4,
                    style: "grayscale_light",
                    language: "en-US",
                    authOptions: this.$store.state.dataView.azureMaps.authOptions
                });

                this.map.events.add("ready", () => {

                    let iconPromises = [
                        this.map.imageSprite.add("icon_depot", "/images/map.depot.png"),
                        this.map.imageSprite.add("icon_site", "/images/map.site.png"),
                    ];

                    Promise.all(iconPromises).then(() => {
                        let depotDatasource = new atlas.source.DataSource();
                        let siteDatasource = new atlas.source.DataSource();

                        for(let pin of pins){
                            if(pin.type != "Feature"){
                                // Just add line settings to depot datasource
                                depotDatasource.add(pin);
                                continue;
                            }

                            if(pin.properties.isDepot)
                                depotDatasource.add(pin);
                            else
                                siteDatasource.add(pin);
                        }

                        this.map.sources.add(depotDatasource);
                        this.map.sources.add(siteDatasource);

                        // Site
                        this.map.layers.add([
                            new atlas.layer.SymbolLayer(siteDatasource, null, {
                                iconOptions: {
                                    allowOverlap: true,
                                    ignorePlacement: true,
                                    image: "icon_site",
                                    size: 0.5
                                },
                                textOptions: {
                                    textField: ["get", "title"],
                                    offset: [0, 1]
                                },
                                filter: ["any", ["==", ["geometry-type"], "Point"], ["==", ["geometry-type"], "MultiPoint"]] //Only render Point or MultiPoints in this layer.
                            })
                        ]);

                        // Depot
                        this.map.layers.add([
                            new atlas.layer.LineLayer(depotDatasource, null, {
                                strokeColor: "#5C5B64",
                                strokeWidth: 1
                            }),
                            new atlas.layer.SymbolLayer(depotDatasource, null, {
                                iconOptions: {
                                    allowOverlap: true,
                                    ignorePlacement: true,
                                    image: "icon_depot",
                                    size: 0.5
                                },
                                textOptions: {
                                    textField: ["get", "title"],
                                    offset: [0, 1]
                                },
                                filter: ["any", ["==", ["geometry-type"], "Point"], ["==", ["geometry-type"], "MultiPoint"]] //Only render Point or MultiPoints in this layer.
                            })
                        ]);

                        
                    });
                });
            },
            getDistributionMapPins(route, pins) {
                route.sites.forEach((site) => {
                    let s = new atlas.data.Feature(new atlas.data.Point([site.location.lon, site.location.lat]), {
                        title: site.locationName,
                        isDepot: false
                    });
                    pins.push(s);

                    let path = atlas.math.getGeodesicPath([[route.location.lon, route.location.lat], [site.location.lon, site.location.lat]]);
                    let poly = new atlas.data.LineString(path);

                    pins.push(poly);
                });

                route.depots.forEach((depot) => {
                    let s = new atlas.data.Feature(new atlas.data.Point([depot.location.lon, depot.location.lat]), {
                        title: depot.locationName,
                        isDepot: true
                    });
                    pins.push(s);

                    let path = atlas.math.getGeodesicPath([[route.location.lon, route.location.lat], [depot.location.lon, depot.location.lat]]);
                    let poly = new atlas.data.LineString(path);

                    pins.push(poly);

                    this.getDistributionMapPins(depot, pins)
                })
            }
        }
    }
</script>
